import { getObjectEntries, getObjectKeys } from '@festina-life/core'
import { buttonStyles } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { FilterCheckbox } from '@festina-life/ui/listsAndTables'
import { Icon } from '@festina-life/ui/structure'
import cx from 'classnames'

import { useApprovalStatusTranslations } from '../../../../hooks/useApprovalStatusTranslations'
import type { ApprovalStatus } from '../../../configurationItemsTree/types'
import { ManageHeader } from '../../../manageHeader/ManageHeader'
import { PreferencesMenu } from '../../../pareferencesMenu/PreferencesMenu'

type Props = {
  approvalStatus: Record<ApprovalStatus, boolean>
  onApprovalStatusChanged: (
    approvalStatus: Record<ApprovalStatus, boolean>,
  ) => void
}

export const BranchChangesetApprovalFilter = ({
  approvalStatus,
  onApprovalStatusChanged,
}: Props) => {
  const translate = useTranslate()
  const approvalStatusTranslations = useApprovalStatusTranslations()
  const areAllApprovalStatusesVisible = getObjectKeys(approvalStatus).every(
    (status) => approvalStatus[status],
  )
  const isSomeFilterSet = !areAllApprovalStatusesVisible

  return (
    <PreferencesMenu
      trigger={
        <Icon
          name="Filter"
          className={cx(
            buttonStyles({
              disabled: false,
              isDanger: false,
              isFullWidth: false,
              variant: 'discreet',
              hasCustomPadding: true,
            }),
            'p-1/2 text-primary-500!',
            { 'fill-warning-500 dark:fill-warning-300': isSomeFilterSet },
          )}
        />
      }
      panelClassName={cx('w-sm fixed!')}
    >
      <ManageHeader
        title={
          <div className="flex w-full justify-between items-center">
            <FilterCheckbox
              label={translate('branchChangesets.filter.approvalStatus')}
              checked={areAllApprovalStatusesVisible}
              onChange={(nextValue) => {
                onApprovalStatusChanged(
                  getObjectKeys(approvalStatus).reduce(
                    (acc, status) => {
                      acc[status] = nextValue
                      return acc
                    },
                    {} as Record<ApprovalStatus, boolean>,
                  ),
                )
              }}
            />
          </div>
        }
        isFaded
      />
      <div className="flex flex-col gap-y-2">
        {getObjectEntries(approvalStatus).map(([status, isVisible]) => (
          <FilterCheckbox
            key={status}
            id={status}
            label={approvalStatusTranslations[status]}
            checked={isVisible}
            onChange={() =>
              onApprovalStatusChanged({
                ...approvalStatus,
                [status]: !isVisible,
              })
            }
          />
        ))}
      </div>
    </PreferencesMenu>
  )
}
